import React from "react";
import "./PopupFile.scss";
import Wix from 'Wix';

class PopupFile extends React.Component {
  
  constructor(props){
    super(props);
    this.escFunction = this.escFunction.bind(this);
  } 

  escFunction(event){
    if(event.keyCode === 27) {
      Wix.closeWindow()
    }
  }

  componentDidMount(){
    window.addEventListener("keydown", this.escFunction, false);
    Wix.addEventListener(Wix.Events.KEY_DOWN, function(event) {
      this.escFunction(event);
    })
  }

  componentWillUnmount(){
    window.removeEventListener("keydown", this.escFunction, false);
  }

  onPopupClose = () => Wix.closeWindow();

  render() {
    const { height, width , deviceType } = this.props.match.params;
    var uri_dec = decodeURIComponent(this.props.match.params.src);
    return (
      uri_dec ? 
    <div className={deviceType} >
        <div 
          ref={node => this.iframe = node} 
          className={`popup-div-iframe`}
          style={deviceType === "mobile" ? {padding:`${height}px ${width}px`}:{}} 
         >
         <button onClick={this.onPopupClose}  className="btn-close" autoFocus></button>
          <iframe
              style={deviceType === "desktop" ? {height: `${height}px`, width:`${width}px`}:{}}
              align='bottom'
              src={uri_dec} 
              onLoad={() => this.iframe.style.visibility = 'visible'} 
              className={"popup-iframe " + (uri_dec.includes('forms') ? "popup-iframe-forms" : "")}
              title="My item" >
         </iframe > 
     </div>
     </div>
        : <div>PopupFile</div>
    );
  }
}

export default PopupFile;



// WEBPACK FOOTER //
// ./src/widget/components/popup/PopupFile.js